import { ROUTE_IDS, OPERATION_IDS } from '../routes/ids.js';
export const ADMIN_RESOURCE_REGISTRY = {
    'platform-organizations': {
        id: 'platform-organizations', authority: 'PLATFORM', scopeKind: 'PLATFORM',
        listRouteId: ROUTE_IDS.PLATFORM_ORGANIZATIONS_LIST, createRouteId: ROUTE_IDS.PLATFORM_ORGANIZATIONS_CREATE,
        detailRouteId: ROUTE_IDS.PLATFORM_ORGANIZATIONS_DETAIL, editRouteId: ROUTE_IDS.PLATFORM_ORGANIZATIONS_EDIT,
        listOperationId: OPERATION_IDS.PLATFORM_ORGANIZATIONS_LIST, readOperationId: OPERATION_IDS.PLATFORM_ORGANIZATIONS_READ,
        createOperationId: OPERATION_IDS.PLATFORM_ORGANIZATIONS_CREATE, updateOperationId: OPERATION_IDS.PLATFORM_ORGANIZATIONS_UPDATE,
        tableDescriptorId: 'table.admin.organizations', listQueryId: 'query.admin.platform-organizations.list',
        readQueryId: 'query.admin.platform-organizations.get',
        createCommandId: 'cmd.admin.platform-organizations.create',
        updateCommandId: 'cmd.admin.platform-organizations.update',
        formDescriptorId: 'form.admin.platformOrganization', ownershipPolicy: 'PLATFORM', rowActivation: 'DETAIL', kind: 'standard-list-detail',
    },
    'platform-modules': {
        id: 'platform-modules', authority: 'PLATFORM', scopeKind: 'PLATFORM', listRouteId: ROUTE_IDS.PLATFORM_MODULES_LIST,
        detailRouteId: ROUTE_IDS.PLATFORM_MODULES_DETAIL, createRouteId: ROUTE_IDS.PLATFORM_MODULE_ASSIGNMENTS,
        listOperationId: OPERATION_IDS.PLATFORM_MODULES_LIST, readOperationId: OPERATION_IDS.PLATFORM_MODULES_READ,
        createOperationId: OPERATION_IDS.PLATFORM_MODULES_ASSIGN, updateOperationId: OPERATION_IDS.PLATFORM_MODULES_ASSIGN,
        deleteOperationId: OPERATION_IDS.PLATFORM_MODULES_REVOKE, tableDescriptorId: 'table.admin.platformModules',
        listQueryId: 'query.admin.platform-modules.list', readQueryId: 'query.admin.platform-modules.get',
        createCommandId: 'cmd.admin.platform-modules.create',
        updateCommandId: 'cmd.admin.platform-modules.update',
        deleteCommandId: 'cmd.admin.platform-modules.delete',
        ownershipPolicy: 'PLATFORM', rowActivation: 'NONE', kind: 'bespoke',
    },
    'platform-users': {
        id: 'platform-users', authority: 'PLATFORM', scopeKind: 'PLATFORM', listRouteId: ROUTE_IDS.PLATFORM_USERS_LIST,
        createRouteId: ROUTE_IDS.PLATFORM_USERS_CREATE, editRouteId: ROUTE_IDS.PLATFORM_USERS_EDIT, detailRouteId: ROUTE_IDS.PLATFORM_USERS_DETAIL,
        listOperationId: OPERATION_IDS.PLATFORM_USERS_LIST, readOperationId: OPERATION_IDS.PLATFORM_USERS_READ,
        createOperationId: OPERATION_IDS.PLATFORM_USERS_CREATE, updateOperationId: OPERATION_IDS.PLATFORM_USERS_UPDATE,
        deleteOperationId: OPERATION_IDS.PLATFORM_USERS_DISABLE, tableDescriptorId: 'table.admin.users',
        listQueryId: 'query.admin.platform-users.list', readQueryId: 'query.admin.platform-users.get',
        createCommandId: 'cmd.admin.platform-users.create', updateCommandId: 'cmd.admin.platform-users.update',
        deleteCommandId: 'cmd.admin.platform-users.delete', formDescriptorId: 'form.admin.user',
        ownershipPolicy: 'PLATFORM', rowActivation: 'DETAIL', kind: 'standard-list-form',
    },
    'platform-audit': {
        id: 'platform-audit', authority: 'PLATFORM', scopeKind: 'PLATFORM', listRouteId: ROUTE_IDS.PLATFORM_AUDIT_LIST,
        detailRouteId: ROUTE_IDS.PLATFORM_AUDIT_DETAIL, listOperationId: OPERATION_IDS.PLATFORM_AUDIT_LIST,
        readOperationId: OPERATION_IDS.PLATFORM_AUDIT_READ, tableDescriptorId: 'table.admin.audit',
        listQueryId: 'query.admin.platform-audit.list', readQueryId: 'query.admin.platform-audit.get',
        ownershipPolicy: 'PLATFORM', rowActivation: 'NONE', kind: 'read-only-list',
    },
    'platform-health': {
        id: 'platform-health', authority: 'PLATFORM', scopeKind: 'SYSTEM', listRouteId: ROUTE_IDS.PLATFORM_HEALTH,
        listOperationId: OPERATION_IDS.PLATFORM_HEALTH_CHECK, tableDescriptorId: 'table.admin.platformHealth',
        listQueryId: 'query.admin.platform-health.list', ownershipPolicy: 'PLATFORM', rowActivation: 'NONE', kind: 'bespoke',
    },
    'platform-support-delegations': {
        id: 'platform-support-delegations', authority: 'PLATFORM', scopeKind: 'PLATFORM',
        listRouteId: ROUTE_IDS.PLATFORM_SUPPORT_DELEGATIONS_LIST, createRouteId: ROUTE_IDS.PLATFORM_SUPPORT_DELEGATIONS_CREATE,
        detailRouteId: ROUTE_IDS.PLATFORM_SUPPORT_DELEGATIONS_DETAIL, editRouteId: ROUTE_IDS.PLATFORM_SUPPORT_DELEGATIONS_REVOKE,
        listOperationId: OPERATION_IDS.PLATFORM_SUPPORT_DELEGATIONS_LIST, readOperationId: OPERATION_IDS.PLATFORM_SUPPORT_DELEGATIONS_READ,
        createOperationId: OPERATION_IDS.PLATFORM_SUPPORT_DELEGATIONS_CREATE,
        updateOperationId: OPERATION_IDS.PLATFORM_SUPPORT_DELEGATIONS_REVOKE,
        deleteOperationId: OPERATION_IDS.PLATFORM_SUPPORT_DELEGATIONS_REVOKE,
        tableDescriptorId: 'table.admin.platformSupportDelegations',
        listQueryId: 'query.admin.platform-support-delegations.list',
        readQueryId: 'query.admin.platform-support-delegations.get',
        createCommandId: 'cmd.admin.platform-support-delegations.create',
        deleteCommandId: 'cmd.admin.platform-support-delegations.revoke',
        formDescriptorId: 'form.admin.platformSupportDelegation',
        ownershipPolicy: 'PLATFORM', rowActivation: 'DETAIL', kind: 'standard-list-form',
    },
    'platform-access-inspector': {
        id: 'platform-access-inspector', authority: 'PLATFORM', scopeKind: 'PLATFORM', listRouteId: ROUTE_IDS.PLATFORM_ACCESS_INSPECTOR,
        listOperationId: OPERATION_IDS.ACCESS_READ_PERMISSIONS, tableDescriptorId: 'table.admin.platformAccessInspector',
        listQueryId: 'query.admin.platform-access-inspector.list',
        ownershipPolicy: 'PLATFORM', rowActivation: 'NONE', kind: 'bespoke',
    },
    'organization-profile': {
        id: 'organization-profile', authority: 'ORGANIZATION', scopeKind: 'ORGANIZATION', listRouteId: ROUTE_IDS.ORGANIZATION_PROFILE,
        detailRouteId: ROUTE_IDS.ORGANIZATION_PROFILE_DETAIL, editRouteId: ROUTE_IDS.ORGANIZATION_PROFILE_EDIT,
        listOperationId: OPERATION_IDS.ORGANIZATION_PROFILE_READ,
        readOperationId: OPERATION_IDS.ORGANIZATION_PROFILE_READ, updateOperationId: OPERATION_IDS.ORGANIZATION_PROFILE_UPDATE,
        tableDescriptorId: 'table.admin.organizationProfile', formDescriptorId: 'form.admin.organizationProfile',
        listQueryId: 'query.admin.organization-profile.list',
        readQueryId: 'query.admin.organization-profile.get',
        updateCommandId: 'cmd.admin.organization-profile.update',
        ownershipPolicy: 'ACTIVE_ORGANIZATION', rowActivation: 'DETAIL', kind: 'standard-list-form',
    },
    'organization-branches': {
        id: 'organization-branches', authority: 'ORGANIZATION', scopeKind: 'ORGANIZATION', listRouteId: ROUTE_IDS.ORGANIZATION_BRANCHES_LIST,
        createRouteId: ROUTE_IDS.ORGANIZATION_BRANCHES_CREATE, detailRouteId: ROUTE_IDS.ORGANIZATION_BRANCHES_DETAIL,
        editRouteId: ROUTE_IDS.ORGANIZATION_BRANCHES_EDIT, listOperationId: OPERATION_IDS.ORGANIZATION_BRANCHES_LIST,
        readOperationId: OPERATION_IDS.ORGANIZATION_BRANCHES_READ, createOperationId: OPERATION_IDS.ORGANIZATION_BRANCHES_CREATE,
        updateOperationId: OPERATION_IDS.ORGANIZATION_BRANCHES_UPDATE, deleteOperationId: OPERATION_IDS.ORGANIZATION_BRANCHES_DISABLE,
        tableDescriptorId: 'table.admin.organizationBranches', listQueryId: 'query.admin.organization-branches.list',
        readQueryId: 'query.admin.organization-branches.get',
        createCommandId: 'cmd.admin.organization-branches.create',
        updateCommandId: 'cmd.admin.organization-branches.update',
        deleteCommandId: 'cmd.admin.organization-branches.delete',
        ownershipPolicy: 'ACTIVE_ORGANIZATION', rowActivation: 'NONE', formDescriptorId: 'form.admin.branch', kind: 'standard-list-form',
    },
    'organization-module-activations': {
        id: 'organization-module-activations', authority: 'ORGANIZATION', scopeKind: 'ORGANIZATION', listRouteId: ROUTE_IDS.ORGANIZATION_MODULES_LIST,
        createRouteId: ROUTE_IDS.ORGANIZATION_MODULES_CREATE, editRouteId: ROUTE_IDS.ORGANIZATION_MODULES_CONFIGURE,
        listOperationId: OPERATION_IDS.ORGANIZATION_MODULES_LIST_ASSIGNED, readOperationId: OPERATION_IDS.ORGANIZATION_MODULES_LIST_ASSIGNED,
        readQueryId: 'query.admin.organization-module-activations.get',
        createOperationId: OPERATION_IDS.ORGANIZATION_MODULES_ENABLE,
        updateOperationId: OPERATION_IDS.ORGANIZATION_MODULES_CONFIGURE, deleteOperationId: OPERATION_IDS.ORGANIZATION_MODULES_DISABLE,
        tableDescriptorId: 'table.admin.organizationModuleAssignments', listQueryId: 'query.admin.organization-module-activations.list',
        createCommandId: 'cmd.admin.organization-module-activations.create',
        updateCommandId: 'cmd.admin.organization-module-activations.update',
        deleteCommandId: 'cmd.admin.organization-module-activations.delete',
        ownershipPolicy: 'ACTIVE_ORGANIZATION', rowActivation: 'NONE', formDescriptorId: 'form.admin.moduleAssignment', kind: 'standard-list-form',
    },
    'organization-users': {
        id: 'organization-users', authority: 'ORGANIZATION', scopeKind: 'ORGANIZATION', listRouteId: ROUTE_IDS.ORGANIZATION_USERS_LIST,
        createRouteId: ROUTE_IDS.ORGANIZATION_USERS_CREATE, editRouteId: ROUTE_IDS.ORGANIZATION_USERS_EDIT,
        detailRouteId: ROUTE_IDS.ORGANIZATION_USERS_DETAIL, listOperationId: OPERATION_IDS.ORGANIZATION_USERS_LIST,
        readOperationId: OPERATION_IDS.ORGANIZATION_USERS_READ, createOperationId: OPERATION_IDS.ORGANIZATION_USERS_CREATE,
        updateOperationId: OPERATION_IDS.ORGANIZATION_USERS_UPDATE, deleteOperationId: OPERATION_IDS.ORGANIZATION_USERS_DISABLE,
        tableDescriptorId: 'table.admin.users', listQueryId: 'query.admin.organization-users.list',
        readQueryId: 'query.admin.organization-users.get',
        createCommandId: 'cmd.admin.organization-users.create',
        updateCommandId: 'cmd.admin.organization-users.update',
        deleteCommandId: 'cmd.admin.organization-users.delete',
        formDescriptorId: 'form.admin.user', ownershipPolicy: 'ACTIVE_ORGANIZATION', rowActivation: 'DETAIL', kind: 'standard-list-form',
    },
    'organization-roles': {
        id: 'organization-roles', authority: 'ORGANIZATION', scopeKind: 'ORGANIZATION', listRouteId: ROUTE_IDS.ORGANIZATION_ROLES_LIST,
        createRouteId: ROUTE_IDS.ORGANIZATION_ROLES_CREATE, editRouteId: ROUTE_IDS.ORGANIZATION_ROLES_EDIT,
        detailRouteId: ROUTE_IDS.ORGANIZATION_ROLES_DETAIL, listOperationId: OPERATION_IDS.ORGANIZATION_ROLES_LIST,
        readOperationId: OPERATION_IDS.ORGANIZATION_ROLES_READ, createOperationId: OPERATION_IDS.ORGANIZATION_ROLES_CREATE,
        updateOperationId: OPERATION_IDS.ORGANIZATION_ROLES_UPDATE, deleteOperationId: OPERATION_IDS.ORGANIZATION_ROLES_DISABLE,
        tableDescriptorId: 'table.admin.roles', listQueryId: 'query.admin.organization-roles.list',
        readQueryId: 'query.admin.organization-roles.get',
        createCommandId: 'cmd.admin.organization-roles.create',
        updateCommandId: 'cmd.admin.organization-roles.update',
        deleteCommandId: 'cmd.admin.organization-roles.delete',
        formDescriptorId: 'form.admin.role', ownershipPolicy: 'ACTIVE_ORGANIZATION', rowActivation: 'DETAIL', kind: 'standard-list-form',
    },
    'organization-permission-assignments': {
        id: 'organization-permission-assignments', authority: 'ORGANIZATION', scopeKind: 'ORGANIZATION',
        listRouteId: ROUTE_IDS.ORGANIZATION_PERMISSION_ASSIGNMENTS_LIST, editRouteId: ROUTE_IDS.ORGANIZATION_PERMISSION_ASSIGNMENTS_EDIT,
        listOperationId: OPERATION_IDS.ORGANIZATION_PERMISSION_ASSIGNMENTS_LIST,
        updateOperationId: OPERATION_IDS.ORGANIZATION_PERMISSION_ASSIGNMENTS_EDIT,
        tableDescriptorId: 'table.admin.organizationPermissionAssignments',
        listQueryId: 'query.admin.organization-permission-assignments.list',
        updateCommandId: 'cmd.admin.organization-permission-assignments.update',
        ownershipPolicy: 'ACTIVE_ORGANIZATION', rowActivation: 'NONE', kind: 'bespoke',
    },
    'organization-clients': {
        id: 'organization-clients', authority: 'ORGANIZATION', scopeKind: 'ORGANIZATION', listRouteId: ROUTE_IDS.ORGANIZATION_CLIENTS_LIST,
        createRouteId: ROUTE_IDS.ORGANIZATION_CLIENTS_CREATE, detailRouteId: ROUTE_IDS.ORGANIZATION_CLIENTS_DETAIL,
        editRouteId: ROUTE_IDS.ORGANIZATION_CLIENTS_EDIT, listOperationId: OPERATION_IDS.ORGANIZATION_CLIENTS_LIST,
        readOperationId: OPERATION_IDS.ORGANIZATION_CLIENTS_READ, createOperationId: OPERATION_IDS.ORGANIZATION_CLIENTS_CREATE,
        updateOperationId: OPERATION_IDS.ORGANIZATION_CLIENTS_UPDATE, deleteOperationId: OPERATION_IDS.ORGANIZATION_CLIENTS_DISABLE,
        tableDescriptorId: 'table.admin.organizationClients', listQueryId: 'query.admin.organization-clients.list',
        readQueryId: 'query.admin.organization-clients.get',
        createCommandId: 'cmd.admin.organization-clients.create',
        updateCommandId: 'cmd.admin.organization-clients.update',
        deleteCommandId: 'cmd.admin.organization-clients.delete',
        formDescriptorId: 'form.admin.client', ownershipPolicy: 'ACTIVE_ORGANIZATION', rowActivation: 'DETAIL', kind: 'standard-list-form',
    },
    'organization-client-accounts': {
        id: 'organization-client-accounts', authority: 'ORGANIZATION', scopeKind: 'ORGANIZATION',
        listRouteId: ROUTE_IDS.ORGANIZATION_CLIENT_ACCOUNTS_LIST, createRouteId: ROUTE_IDS.ORGANIZATION_CLIENT_ACCOUNTS_CREATE,
        detailRouteId: ROUTE_IDS.ORGANIZATION_CLIENT_ACCOUNTS_DETAIL, editRouteId: ROUTE_IDS.ORGANIZATION_CLIENT_ACCOUNTS_EDIT,
        listOperationId: OPERATION_IDS.ORGANIZATION_CLIENT_ACCOUNTS_LIST, readOperationId: OPERATION_IDS.ORGANIZATION_CLIENT_ACCOUNTS_READ,
        createOperationId: OPERATION_IDS.ORGANIZATION_CLIENT_ACCOUNTS_CREATE, updateOperationId: OPERATION_IDS.ORGANIZATION_CLIENT_ACCOUNTS_UPDATE,
        deleteOperationId: OPERATION_IDS.ORGANIZATION_CLIENT_ACCOUNTS_DISABLE,
        tableDescriptorId: 'table.admin.organizationClientAccounts', listQueryId: 'query.admin.organization-client-accounts.list',
        readQueryId: 'query.admin.organization-client-accounts.get',
        createCommandId: 'cmd.admin.organization-client-accounts.create',
        updateCommandId: 'cmd.admin.organization-client-accounts.update',
        deleteCommandId: 'cmd.admin.organization-client-accounts.delete',
        formDescriptorId: 'form.admin.clientAccount', ownershipPolicy: 'ACTIVE_ORGANIZATION', rowActivation: 'DETAIL', kind: 'standard-list-form',
    },
    'organization-portfolios': {
        id: 'organization-portfolios', authority: 'ORGANIZATION', scopeKind: 'ORGANIZATION', listRouteId: ROUTE_IDS.ORGANIZATION_PORTFOLIOS_LIST,
        createRouteId: ROUTE_IDS.ORGANIZATION_PORTFOLIOS_CREATE, detailRouteId: ROUTE_IDS.ORGANIZATION_PORTFOLIOS_DETAIL,
        editRouteId: ROUTE_IDS.ORGANIZATION_PORTFOLIOS_EDIT, listOperationId: OPERATION_IDS.ORGANIZATION_PORTFOLIOS_LIST,
        readOperationId: OPERATION_IDS.ORGANIZATION_PORTFOLIOS_READ, createOperationId: OPERATION_IDS.ORGANIZATION_PORTFOLIOS_CREATE,
        updateOperationId: OPERATION_IDS.ORGANIZATION_PORTFOLIOS_UPDATE,
        deleteOperationId: OPERATION_IDS.ORGANIZATION_PORTFOLIOS_DISABLE,
        tableDescriptorId: 'table.admin.organizationPortfolios',
        listQueryId: 'query.admin.organization-portfolios.list',
        readQueryId: 'query.admin.organization-portfolios.get',
        createCommandId: 'cmd.admin.organization-portfolios.create',
        updateCommandId: 'cmd.admin.organization-portfolios.update',
        deleteCommandId: 'cmd.admin.organization-portfolios.delete',
        formDescriptorId: 'form.admin.portfolio', ownershipPolicy: 'ACTIVE_ORGANIZATION', rowActivation: 'DETAIL', kind: 'standard-list-form',
    },
    'organization-audit': {
        id: 'organization-audit', authority: 'ORGANIZATION', scopeKind: 'ORGANIZATION', listRouteId: ROUTE_IDS.ORGANIZATION_AUDIT_LIST,
        detailRouteId: ROUTE_IDS.ORGANIZATION_AUDIT_DETAIL, listOperationId: OPERATION_IDS.ORGANIZATION_AUDIT_LIST,
        readOperationId: OPERATION_IDS.ORGANIZATION_AUDIT_READ, tableDescriptorId: 'table.admin.organizationAudit',
        listQueryId: 'query.admin.organization-audit.list',
        readQueryId: 'query.admin.organization-audit.get',
        ownershipPolicy: 'ACTIVE_ORGANIZATION', rowActivation: 'DETAIL', kind: 'read-only-list',
    },
    'organization-access-inspector': {
        id: 'organization-access-inspector', authority: 'ORGANIZATION', scopeKind: 'ORGANIZATION',
        listRouteId: ROUTE_IDS.ORGANIZATION_ACCESS_INSPECTOR, listOperationId: OPERATION_IDS.ORGANIZATION_ACCESS_INSPECTOR_READ,
        listQueryId: 'query.admin.organization-access-inspector.list',
        ownershipPolicy: 'ACTIVE_ORGANIZATION', rowActivation: 'NONE', kind: 'bespoke',
    },
    'organization-jurisdiction-settings': {
        id: 'organization-jurisdiction-settings', authority: 'ORGANIZATION', scopeKind: 'ORGANIZATION',
        listRouteId: ROUTE_IDS.ORGANIZATION_JURISDICTION_SETTINGS,
        listOperationId: OPERATION_IDS.ORGANIZATION_JURISDICTION_SETTINGS_READ,
        readOperationId: OPERATION_IDS.ORGANIZATION_JURISDICTION_SETTINGS_READ,
        updateOperationId: OPERATION_IDS.ORGANIZATION_JURISDICTION_SETTINGS_UPDATE,
        listQueryId: 'query.admin.organization-jurisdiction-settings.list',
        readQueryId: 'query.admin.organization-jurisdiction-settings.get',
        updateCommandId: 'cmd.admin.organization-jurisdiction-settings.update',
        ownershipPolicy: 'ACTIVE_ORGANIZATION', rowActivation: 'NONE', kind: 'bespoke',
    },
    'organization-opening-cutover': {
        id: 'organization-opening-cutover', authority: 'ORGANIZATION', scopeKind: 'ORGANIZATION',
        listRouteId: ROUTE_IDS.ADMIN_OPENING_CUTOVER_LIST, createRouteId: ROUTE_IDS.ADMIN_OPENING_CUTOVER_CREATE,
        detailRouteId: ROUTE_IDS.ADMIN_OPENING_CUTOVER_DETAIL, editRouteId: ROUTE_IDS.ADMIN_OPENING_CUTOVER_EDIT,
        listOperationId: OPERATION_IDS.ACCOUNTING_OPENING_CUTOVER_GET,
        readOperationId: OPERATION_IDS.ACCOUNTING_OPENING_CUTOVER_GET,
        createOperationId: OPERATION_IDS.ACCOUNTING_OPENING_CUTOVER_PREVIEW,
        updateOperationId: OPERATION_IDS.ACCOUNTING_OPENING_CUTOVER_PREVIEW,
        tableDescriptorId: 'table.admin.openingCutover',
        listQueryId: 'query.admin.organization-opening-cutover.list',
        readQueryId: 'query.admin.organization-opening-cutover.get',
        createCommandId: 'cmd.admin.organization-opening-cutover.create',
        updateCommandId: 'cmd.admin.organization-opening-cutover.preview',
        formDescriptorId: 'form.admin.openingCutover',
        ownershipPolicy: 'ACTIVE_ORGANIZATION', rowActivation: 'DETAIL', kind: 'standard-list-form',
    },
    'organization-opening-cutover-history': {
        id: 'organization-opening-cutover-history', authority: 'ORGANIZATION', scopeKind: 'ORGANIZATION',
        listRouteId: ROUTE_IDS.ADMIN_OPENING_CUTOVER_HISTORY,
        listOperationId: OPERATION_IDS.ACCOUNTING_OPENING_CUTOVER_APPROVE,
        readOperationId: OPERATION_IDS.ACCOUNTING_OPENING_CUTOVER_GET,
        tableDescriptorId: 'table.admin.openingCutover',
        listQueryId: 'query.admin.organization-opening-cutover.list',
        readQueryId: 'query.admin.organization-opening-cutover.get',
        ownershipPolicy: 'ACTIVE_ORGANIZATION', rowActivation: 'DETAIL', kind: 'standard-list-form',
    },
    'organization-tax-rules': {
        id: 'organization-tax-rules', authority: 'ORGANIZATION', scopeKind: 'ORGANIZATION',
        listRouteId: ROUTE_IDS.ADMIN_TAX_RULES_LIST, createRouteId: ROUTE_IDS.ADMIN_TAX_RULES_CREATE,
        detailRouteId: ROUTE_IDS.ADMIN_TAX_RULES_DETAIL, editRouteId: ROUTE_IDS.ADMIN_TAX_RULES_EDIT,
        listOperationId: OPERATION_IDS.TAX_RULE_LIST,
        readOperationId: OPERATION_IDS.TAX_RULE_READ,
        createOperationId: OPERATION_IDS.TAX_RULE_CREATE_VERSION,
        updateOperationId: OPERATION_IDS.TAX_RULE_SUBMIT,
        tableDescriptorId: 'table.admin.taxRules',
        listQueryId: 'query.admin.organization-tax-rules.list',
        readQueryId: 'query.admin.organization-tax-rules.get',
        createCommandId: 'cmd.admin.organization-tax-rules.create',
        updateCommandId: 'cmd.admin.organization-tax-rules.update',
        formDescriptorId: 'form.admin.taxRule',
        ownershipPolicy: 'ACTIVE_ORGANIZATION', rowActivation: 'DETAIL', kind: 'standard-list-form',
    },
    'organization-fee-rules': {
        id: 'organization-fee-rules', authority: 'ORGANIZATION', scopeKind: 'ORGANIZATION',
        listRouteId: ROUTE_IDS.ADMIN_FEE_RULES_LIST, createRouteId: ROUTE_IDS.ADMIN_FEE_RULES_CREATE,
        detailRouteId: ROUTE_IDS.ADMIN_FEE_RULES_DETAIL, editRouteId: ROUTE_IDS.ADMIN_FEE_RULES_EDIT,
        listOperationId: OPERATION_IDS.FEE_RULE_LIST,
        readOperationId: OPERATION_IDS.FEE_RULE_READ,
        createOperationId: OPERATION_IDS.FEE_RULE_CREATE_VERSION,
        updateOperationId: OPERATION_IDS.FEE_RULE_SUBMIT,
        tableDescriptorId: 'table.admin.feeRules',
        listQueryId: 'query.admin.organization-fee-rules.list',
        readQueryId: 'query.admin.organization-fee-rules.get',
        createCommandId: 'cmd.admin.organization-fee-rules.create',
        updateCommandId: 'cmd.admin.organization-fee-rules.update',
        formDescriptorId: 'form.admin.feeRule',
        ownershipPolicy: 'ACTIVE_ORGANIZATION', rowActivation: 'DETAIL', kind: 'standard-list-form',
    },
};
